import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import LiveCountSlick from "./LiveCountSlick";
import axios from "axios";
import "./livecounts.css";
import "../StatisticsPage/charts.css";
import { io } from "socket.io-client";

//const port = "https://adityauniversity.in/blooddonationbackend"; // Replace with your server URL if needed

// const port = process.env.REACT_APP_SERVER_PORT
const port = process.env.REACT_APP_SERVER_PORT;

const StatisticsPage = (props) => {
  const navigate = useNavigate();
  
  const [liveCounts, setLiveCounts] = useState(0); // State for live counts
  const [noEvent, setNoEvent] = useState(false);

  const fetchLiveCounts = async () => {
    try {
      const response = await axios.get(`${port}count-by-gender?EventDate=YES`);
      if (response.data && response.data.data) {
        // Calculate the total count from the response
        const totalCounts = response.data.data.reduce(
          (acc, item) => acc + item.value,
          0
        );
        setLiveCounts(totalCounts); // Update live counts
        setNoEvent(totalCounts === 0); // Set `noEvent` if the total count is 0
      } else {
        setLiveCounts(0);
        setNoEvent(true);
      }
    } catch (error) {
      console.error("Error fetching live counts:", error);
      setLiveCounts(0);
      setNoEvent(true);
    }
    finally {
      setTimeout(fetchLiveCounts, 10000);
    }
  };

  useEffect(() => {
    // Fetch live counts on initial render
    fetchLiveCounts();

    // Initialize the socket connection
    const socket = io(port, {
      transports: ["websocket"],
    });

    // Listen for the "new-registration" event
    socket.on("new-registration", () => {
      console.log("New registration detected");
      fetchLiveCounts(); // Fetch updated live counts
    });

    // Cleanup the socket connection and event listener
    return () => {
      socket.off("new-registration"); // Remove the listener
      socket.disconnect(); // Disconnect the socket
    };
  }, []);


  return (
    <Fragment>
      <Header hclass={"header--styleFour"} />
      <main className="main" style={{ marginBottom: "40px" }}>
        <PageTitle pageTitle={"LIVE STATISTICS"} pagesub={"LIVE STATISTICS"} />
        <div className="header-stat">
          <div className="drop-down-clgs">
            <button onClick={() => navigate('/blooddonation/stats')} className='live-counts-btn'>
              Statistics
            </button>
          </div>
        </div>
        <div 
          className="live-count-title"
        >
          Live Count {liveCounts}
        </div>

        <div
          className="live-slider-wrapper"
        >
          <LiveCountSlick />
        </div>
      </main>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default StatisticsPage;
